import State from '../core/State';
import produce, { Draft } from 'immer';
import { OrderDirection } from '@kaizenplatform/intelligence-entity';

export const setOrder = (order: OrderDirection) =>
  produce((draft: Draft<State>) => {
    draft.order = order;
  });
